import React from "react";
import "./spinner.css";

const Spinner: React.FC = () => {
  return (
    <div className="spinner-container">
      <div className="loading-spinner"></div>
    </div>
  );
}

export default Spinner;